'use client';

/**
 * Vercel Web Analytics + Speed Insights, gated on the visitor's privacy
 * signals. Both scripts load as before, but every event is dropped in
 * `beforeSend` when Do Not Track or Global Privacy Control is on, which is
 * the opt-out the privacy policy promises.
 */

import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/next';
import { hasPrivacyOptOutSignal } from '@/lib/analytics/privacy-signals';

export function dropIfOptedOut<T>(event: T): T | null {
  return hasPrivacyOptOutSignal() ? null : event;
}

export function VercelTelemetry() {
  return (
    <>
      <Analytics debug={false} beforeSend={dropIfOptedOut} />
      <SpeedInsights sampleRate={0.1} beforeSend={dropIfOptedOut} />
    </>
  );
}
